export class GetCatalogTree {
  static readonly type = '[Dictionaries] Get Catalog Tree';
  constructor() {}
}
